//@require("./myStringify.js");

try{// 加密
;(function(){
    /*
   * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
   * Digest Algorithm, as defined in RFC 1321.
   * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
   * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
   * Distributed under the BSD License
   * See http://pajhome.org.uk/crypt/md5 for more info.
   */
  /*
   * Configurable variables. You may need to tweak these to be compatible with
   * the server-side, but the defaults work in most cases.
   */
  var hexcase = 0;  /* hex output format. 0 - lowercase; 1 - uppercase        */
  var b64pad  = ""; /* base-64 pad character. "=" for strict RFC compliance   */
  var chrsz   = 8;  /* bits per input character. 8 - ASCII; 16 - Unicode      */
  /*
   * These are the functions you'll usually want to call
   * They take string arguments and return either hex or base-64 encoded strings
   */
  window.hex_md5 = function(s){ return binl2hex(core_md5(str2binl(s), s.length * chrsz));}
  function b64_md5(s){ return binl2b64(core_md5(str2binl(s), s.length * chrsz));}
  function str_md5(s){ return binl2str(core_md5(str2binl(s), s.length * chrsz));}
  function hex_hmac_md5(key, data) { return binl2hex(core_hmac_md5(key, data)); }
  function b64_hmac_md5(key, data) { return binl2b64(core_hmac_md5(key, data)); }
  function str_hmac_md5(key, data) { return binl2str(core_hmac_md5(key, data)); }
  /*
   * Perform a simple self-test to see if the VM is working
   */
  function md5_vm_test()
  {
    return hex_md5("abc") == "900150983cd24fb0d6963f7d28e17f72";
  }
  /*
   * Calculate the MD5 of an array of little-endian words, and a bit length
   */
  function core_md5(x, len)
  {
    /* append padding */
    x[len >> 5] |= 0x80 << ((len) % 32);
    x[(((len + 64) >>> 9) << 4) + 14] = len;
    var a =  1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d =  271733878;
    for(var i = 0; i < x.length; i += 16)
    {
      var olda = a;
      var oldb = b;
      var oldc = c;
      var oldd = d;
      a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
      d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
      c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
      b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
      a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
      d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
      c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
      b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
      a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
      d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
      c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
      b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
      a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
      d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
      c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
      b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
      a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
      d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
      c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
      b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
      a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
      d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
      c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
      b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
      a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
      d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
      c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
      b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
      a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
      d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
      c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
      b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
      a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
      d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
      c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
      b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
      a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
      d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
      c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
      b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
      a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
      d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
      c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
      b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
      a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
      d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
      c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
      b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
      a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
      d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
      c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
      b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
      a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
      d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
      c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
      b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
      a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
      d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
      c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
      b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
      a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
      d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
      c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
      b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
      a = safe_add(a, olda);
      b = safe_add(b, oldb);
      c = safe_add(c, oldc);
      d = safe_add(d, oldd);
    }
    return Array(a, b, c, d);
  }
  /*
   * These functions implement the four basic operations the algorithm uses.
   */
  function md5_cmn(q, a, b, x, s, t)
  {
    return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
  }
  function md5_ff(a, b, c, d, x, s, t)
  {
    return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
  }
  function md5_gg(a, b, c, d, x, s, t)
  {
    return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
  }
  function md5_hh(a, b, c, d, x, s, t)
  {
    return md5_cmn(b ^ c ^ d, a, b, x, s, t);
  }
  function md5_ii(a, b, c, d, x, s, t)
  {
    return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
  }
  /*
   * Calculate the HMAC-MD5, of a key and some data
   */
  function core_hmac_md5(key, data)
  {
    var bkey = str2binl(key);
    if(bkey.length > 16) bkey = core_md5(bkey, key.length * chrsz);
    var ipad = Array(16), opad = Array(16);
    for(var i = 0; i < 16; i++)
    {
      ipad[i] = bkey[i] ^ 0x36363636;
      opad[i] = bkey[i] ^ 0x5C5C5C5C;
    }
    var hash = core_md5(ipad.concat(str2binl(data)), 512 + data.length * chrsz);
    return core_md5(opad.concat(hash), 512 + 128);
  }
  /*
   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
   * to work around bugs in some JS interpreters.
   */
  function safe_add(x, y)
  {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return (msw << 16) | (lsw & 0xFFFF);
  }
  /*
   * Bitwise rotate a 32-bit number to the left.
   */
  function bit_rol(num, cnt)
  {
    return (num << cnt) | (num >>> (32 - cnt));
  }
  /*
   * Convert a string to an array of little-endian words
   * If chrsz is ASCII, characters >255 have their hi-byte silently ignored.
   */
  function str2binl(str)
  {
    var bin = Array();
    var mask = (1 << chrsz) - 1;
    for(var i = 0; i < str.length * chrsz; i += chrsz)
      bin[i>>5] |= (str.charCodeAt(i / chrsz) & mask) << (i%32);
    return bin;
  }
  /*
   * Convert an array of little-endian words to a string
   */
  function binl2str(bin)
  {
    var str = "";
    var mask = (1 << chrsz) - 1;
    for(var i = 0; i < bin.length * 32; i += chrsz)
      str += String.fromCharCode((bin[i>>5] >>> (i % 32)) & mask);
    return str;
  }
  /*
   * Convert an array of little-endian words to a hex string.
   */
  function binl2hex(binarray)
  {
    var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
    var str = "";
    for(var i = 0; i < binarray.length * 4; i++)
    {
      str += hex_tab.charAt((binarray[i>>2] >> ((i%4)*8+4)) & 0xF) +
             hex_tab.charAt((binarray[i>>2] >> ((i%4)*8  )) & 0xF);
    }
    return str;
  }
  /*
   * Convert an array of little-endian words to a base-64 string
   */
  function binl2b64(binarray)
  {
    var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var str = "";
    for(var i = 0; i < binarray.length * 4; i += 3)
    {
      var triplet = (((binarray[i   >> 2] >> 8 * ( i   %4)) & 0xFF) << 16)
                  | (((binarray[i+1 >> 2] >> 8 * ((i+1)%4)) & 0xFF) << 8 )
                  |  ((binarray[i+2 >> 2] >> 8 * ((i+2)%4)) & 0xFF);
      for(var j = 0; j < 4; j++)
      {
        if(i * 8 + j * 6 > binarray.length * 32) str += b64pad;
        else str += tab.charAt((triplet >> 6*(3-j)) & 0x3F);
      }
    }
    return str;
  }
})()
}catch(e){throw new Error(e+" ./md5.js");}

try{/**
    平台及版本判断
    登录状态判断
    suda发起
    元素状态显示收起
    发起请求
**/
;(function (win, doc) {
    'use strict';
    /**
        此类包含了平台判断及版本判断
    **/
    var MyUtility = function(){
        this.UA = navigator.appVersion.toLowerCase();
        this.uaIDs = {
            weibo       : 'weibo',
            sinanews    : 'sinanews',
            qqBrowser   : 'mqqbrowser/',
            ucBrowser   : 'ucbrowser/',
            baidu       : 'baidu',
            weixin      : 'micromessenger' ,
            qq          : 'qq',
            iphone      : 'iphone',
            ipod        : 'ipod'
        };
        this.systems = {
            ios     : 'ios',
            android : 'android'
        };
        this.personURL = 'http://my.sina.cn/?vt=4';
    }
    MyUtility.prototype = {
        sudaLog : function( sudaName ){
            var obj = {
                'name' : sudaName,
                'type' : '',
                'title' : '',
                'index' : '',
                'href' : ''};
            if( typeof(win.suds_count) == 'function' || win.suds_count)
            {
                win.suds_count && win.suds_count( obj );
            }
        },
        insertDOM : function( ele, domStr){
            ele.append(domStr);
        },
        includeStr : function( allStr, matchStr){
            return allStr.indexOf(matchStr)!=-1;
        },
        showEle : function( eleID, isShow, showTime){
            var _$ele = $(eleID);
            if(typeof isDelay != undefined){ 
                var time = (parseInt(showTime)>0)?parseInt(showTime):3000;
                isShow && _$ele.show(time);
                !isShow && _$ele.hide('fast');
                return;
            }
            isShow && _$ele.show();
            !isShow && _$ele.hide();
        },
        ajaxByJsonp : function(url){
            //使用$.ajax发起jsonp请求，会在url请求的时候自动添加callback=json1的字符串导致报错，换成普通插入DOM节点的形式可以避免此种情况
            var head = doc.getElementsByTagName('head')[0],
                script = doc.createElement('script');
            script.src = url;
            script.charset = 'utf-8';
            head.appendChild(script);
        },
        getEvent : function(){
            if(doc.all)  return win.event;    
            func=getEvent.caller;        
            while(func!=null){  
                var arg0=func.arguments[0]; 
                if(arg0) 
                { 
                  if((arg0.constructor==Event || arg0.constructor ==MouseEvent) || 
                        (typeof(arg0)=="object" && arg0.preventDefault && arg0.stopPropagation))
                  {  
                  return arg0; 
                  } 
                } 
                func=func.caller; 
            } 
            return null; 
        },
        preventEvent : function(e){
            //如果提供了事件对象，则这是一个非IE浏览器 
            if ( e && e.preventDefault ) {
                //阻止默认浏览器动作(W3C) 
                e.preventDefault(); 
            }
            else{
                //IE中阻止函数器默认动作的方式 
                win.event.returnValue = false; 
            }
            return false;
        },
        tokenListner : function(){
            var self = this;
            $('.re_cancel').each(function(){
                $(this).on('click', function(){
                    self.showToken();
                });
            });
            
            $('.re_ok').each(function(){
                $(this).on('click', function(){
                    self.showToken();
                    win.location.href = $(this).data('url');
                });
            });
        },
        insertToken : function(){
            var arr = [];
            if( $('.re_box').length < 1)
            {
                //插入提示浮层
                arr.push('<section>');
                arr.push('<div class="re_box">');
                arr.push('<div class="resault_f re_simple">收藏失败!</div>');
                arr.push('<div class="resault_f re_notice">');
                arr.push('<div>');
                arr.push('<p>您已收藏，请到个人中心查看</p>');
                arr.push('</div>');
                arr.push('<span class="re_cancel">知道了</span>');
                arr.push('<span class="re_ok" data-url="'+this.personURL+'">去看看</span>');
                arr.push('</div>');
                arr.push('</div>');
                arr.push('</section>');
                
                this.insertDOM($('body'),arr.join(''));
                this.tokenListner();
            }
            return;
        },
        showToken : function( txt, isOnlyToken){
            var _$tokenBox = $('.re_box'),
                _$tokenWindow_1 = '',
                _$tokenWindow_2 = '';
            if( _$tokenBox.length<=0 )
            {
                this.insertToken();
            }
            _$tokenBox = $('.re_box'),
            _$tokenWindow_1 = $('.resault_f').eq(0),
            _$tokenWindow_2 = $('.resault_f').eq(1);
            if( this.tokenTimer )
                clearTimeout( this.tokenTimer );
                
            if(_$tokenWindow_1.hasClass('showFadeAnimate'))
            {
                _$tokenWindow_1.html('').hide().removeClass('showFadeAnimate');
            }
            
            if(_$tokenWindow_2.hasClass('showAnimate'))
            {           
                _$tokenWindow_2.find('p').html('');
                _$tokenWindow_2.hide().removeClass('showAnimate');
            }
            
            if(typeof(isOnlyToken)=='undefined'){
                return;
            }
            else if(isOnlyToken){
                _$tokenWindow_1.show().html(txt).addClass('showFadeAnimate');
                this.tokenTimer = setTimeout(function(){
                    _$tokenWindow_1.html('').hide().removeClass('showFadeAnimate');
                }, 5000);
            }
            else if( !isOnlyToken ){
                _$tokenWindow_2.show().addClass('showAnimate').find('p').html(txt);
            }       
        },
        getShowNum : function(number){
            return number>0?(number>10000?(parseInt(number/10000)+'万'):number) : 0;
        },
        isWeiboApp : function(){
            var include = this.includeStr( this.UA, this.uaIDs.weibo);
            if(include){ 
                return true;
            }
            return false;
        },
        isSinanews : function(){
            var include = this.includeStr( this.UA, this.uaIDs.sinanews);
            if(include){ 
                return true;
            }
            return false;        
        },
        isQQBrowser : function(){
            var include = this.includeStr( this.UA, this.uaIDs.qqBrowser);
            if(include){ 
                return true;
            }
            return false;
        },
        isUCBrowser : function(){
            var include = this.includeStr( this.UA, this.uaIDs.ucBrowser);
            if(include){ 
                return true;
            }
            return false;
        },
        isBaiduBrowser : function(){
            var include = this.includeStr( this.UA, this.uaIDs.baidu);
            if(include){ 
                return true;
            }
            return false;
        },
        isWeixinApp : function(){
            var include = this.includeStr( this.UA, this.uaIDs.weixin);
            if(include){ 
                return true;
            }
            return false;
        },
        isQQApp : function(){
            var _isQQ = this.includeStr( this.UA, this.uaIDs.qq),
                _isNetType = this.includeStr( this.UA, 'nettype');
            if( _isQQ && _isNetType ){
                return true;
            }
            return false;
        },
        isAndroid : function(){
            var platform = this.getPlatform();
            if(platform == this.systems.android){
                return true;
            }
            return false;
        },
        isIOS : function(){
            var platform = this.getPlatform();
            if(platform == this.systems.ios){
                return true;
            }
            return false;
        },
        getSystem : function(){
            return this.systems;
        },
        getPlatform : function(){
            var _iIphone = this.includeStr( this.UA, this.uaIDs.iphone),            
                _iIpod = this.includeStr( this.UA, this.uaIDs.ipod);
            if( _iIphone || _iIpod ){     
                return this.systems.ios;
            }   
            return this.systems.android;
        },
        //获取UC or QQ浏览器的版本
        getBrowserVersion : function(){
            var _isUC = this.isUCBrowser(),
                _isQQ = this.isQQBrowser(),
                _UA = this.UA,
                version = 0;
            function _getVersion(str){
                var arr = str.split('.'),
                    version = 0;
                version = parseFloat(arr[0]+'.'+parseInt(arr[1]));
            
                return version;
            }
            if(_isUC){
                version = _getVersion(_UA.split(this.uaIDs.ucBrowser)[1]);
            }
            else if(_isQQ){
                version = _getVersion(_UA.split(this.uaIDs.qqBrowser)[1]);
            }
            return version;
        },
        getAllPlatformsInfo : function(){
            return {
                isWeiboApp  : this.isWeiboApp(),
                isSinanews : this.isSinanews(),
                isBaiduBrowser : this.isBaiduBrowser(),
                isWeixinApp : this.isWeixinApp(),
                isQQApp     : this.isQQApp() && !this.isWeixinApp(),
                isQQBrowser : this.isQQBrowser() && !this.isQQApp() && !this.isWeixinApp(),
                isUCBrowser : this.isUCBrowser(),
                system      : this.getPlatform(),
                version     : this.getBrowserVersion()
            }
        },
        getScreenInfo : function(){
            var W = win.innerWidth,
                H = win.innerHeight,
                dd = doc.documentElement,
                db = doc.body;
            return {
                width : W || Math.min( dd.clientHeight, db.clientHeight) || 320,
                height : H || Math.min( dd.clientHeight, db.clientHeight) || 480,
                scrollTop : db.scrollTop || dd.scrollTop || 0,
                scrollLeft : db.scrollLeft || dd.scrollLeft || 0
            }
        }
    };
    var GetBrowserInfo = function(){
        var versionLevel = {
                QQ : {ios:5.4,android:5.3,lower:5.4},
                UC : {ios:10.2,android:9.7}
            },
            browserStatus = {
                forbid:0, lower:1, higher:2
            },
            curShareStatus = {
                UC : browserStatus.forbid, QQ : browserStatus.forbid
            },
            myUtility = new MyUtility(),
            allPlatformInfo = myUtility.getAllPlatformsInfo(),
            systems = myUtility.systems;
        function getPlatforms(){
            var allInfo = {},
                tmpInfo = allPlatformInfo,
                UCCanShare  = (curShareStatus.UC>browserStatus.forbid)?true:false,
                QQCanShare  = (curShareStatus.QQ>browserStatus.forbid)?true:false,
                isWeinxin   = tmpInfo.isWeixinApp,
                isWeibo     = tmpInfo.isWeiboApp,
                isQQApp     = tmpInfo.isQQApp;
            allInfo['SinaWeibo'] = true;
            allInfo['WechatFriends'] = allInfo['WechatTimeline'] = UCCanShare || QQCanShare || isWeinxin ||isWeibo || isQQApp;
            //console.dir(allInfo);
            return allInfo;
        };
        function initBrowserVersion(){
            var _allPlatformInfo = allPlatformInfo,
                _systems = systems,
                _isQQBrowser = _allPlatformInfo.isQQBrowser,
                _isUCBrowser = _allPlatformInfo.isUCBrowser,
                _version = _allPlatformInfo.version,
                _mySystem = _allPlatformInfo.system,
                _vQQLevel = versionLevel.QQ,
                _vUCLevel = versionLevel.UC,
                _bStatus = browserStatus;
            var _isUCAndroid    = _version>=_vUCLevel.android && _mySystem == _systems.android,
                _isUCIOS        = _version>=_vUCLevel.ios && _mySystem == _systems.ios,
                _isQQAndroidLower   = _version>=_vQQLevel.android && _mySystem == _systems.android,
                _isQQAndroidHigher  = _version>=_vQQLevel.lower && _mySystem == _systems.android,
                _isQQIOSHigher      = _version>=_vQQLevel.ios && _mySystem == _systems.ios;
            if(_isUCBrowser && (_isUCAndroid||_isUCIOS))
            {
                curShareStatus.UC = _bStatus.higher;
            }
            else if(_isQQBrowser && (_isQQAndroidHigher||_isQQIOSHigher))
            {
                curShareStatus.QQ = _bStatus.higher;
            }
            else if(_isQQBrowser && _isQQAndroidLower && !_isQQAndroidHigher)
            {
                curShareStatus.QQ = _bStatus.lower;
            }
            var platforms = getPlatforms();
            for(var o in platforms){
                curShareStatus[o] = platforms[o];
            }
            return curShareStatus;
        };
        return initBrowserVersion();
    }
    if (!win.sinaCnShare) {
        win.sinaCnShare = {};
        win.sinaCnShare['myUtility'] = new MyUtility();
        win.sinaCnShare['getBrowserInfo'] = new GetBrowserInfo();
        // win.sinaCnShare = Object.create({}, {
        //     myUtility: {
        //         value: new MyUtility()
        //     },
        //     getBrowserInfo : {
        //         value: new GetBrowserInfo()
        //     }
        // });
    }
})(window, document);
//登录相关
;(function(win,doc){
    /**
    *此类包含了登录功能
    **/
    function WapLogin()
    {
        var self = this;
        this.openLogin = function( callback, arg1)
        {
            var isLogintmp = false;
            //背景出现
            //_showBg( _platBox.findId.sharefloat, false);
            
            //呼出登录浮层
            if( typeof(callback)!='undefined' && typeof(arg1) !='undefined')
            {
                this.myLogin( isLogintmp, callback ,arg1);
            }
            else if( typeof(callback) != 'undefined' )
            {
                this.myLogin( isLogintmp, callback);
            }
            else
            {
                this.myLogin( isLogintmp );     
            }
        }
        this.myLogin = function(login, callback, cbparam, cbparam1)
        {
            if(!userInfo)
            {
                this.login (login, callback, cbparam, cbparam1);
            }
        }
        this.login = function ( login, callback, cbparam, cbparam1) //登录状态、回调函数、回调参数1、回调参数2
        {
            var argsnum = arguments.length;
            
            //在window中判断有没有SINA_OUTLOGIN_LAYER来确定有没有浮层对象及是否登录
            if( window["SINA_OUTLOGIN_LAYER"] && !login )
            {
                //获取登录对象
                _loginLayer = window["SINA_OUTLOGIN_LAYER"];
                //初始化浮层
                _loginLayer.set('sso',{
                entry : 'wapsso'
                }).init();
                //将呼出浮层绑定到相应的目标元素上
                            
                _loginLayer.show();
            
                //登陆成功后的回调事件注册多个login_success事件来对应不同按钮的登陆行为
                _loginLayer.register("login_success", function(re){
                    
                    //表示登陆成功
                    self.updateUserInfo( re );
                    
                    switch( argsnum )
                    {
                        case 2:
                            callback();
                            break;
                        case 3:
                            callback( cbparam );
                            break;
                        case 4:
                            callback( cbparam , cbparam1);
                            break;
                        default:
                            window.location.href = window.location.href;
                            break;
                    }
                });
                
                //关闭浮层触发的事件
                _loginLayer.register("layer_hide", function(){
                    callback = null;
                });
            }
            
            return false;
        }   
        
        this.updateUserInfo = function(re)
        {
            if( typeof(re) != 'undefined' && typeof(re.nick) != 'undefined')
            {
                
                window.userInfo = {};
                window.userInfo.uname = re.nick;
                window.userInfo.userface = re.portrait;
                window.userInfo.uid = re.uid;
                window.userInfo.islogin = 1;
                
                //update userface
                var userImgs = ['#loginBox','#loginImg','.userImage'],
                    $login = $('#footer_entry');
                
                for(var o=0;o<userImgs.length;o++)
                {
                    var $tmp = $(userImgs[o]);
                    if( $tmp.length>0 && $tmp.find('img').length>0 )
                    {
                        $tmp.find('img').attr('src',re.portrait);
                    }
                    else if( $tmp.length>0 && $tmp.find('img').length<=0)
                    {
                        var imgIcon = '<img src="'+re.portrait+'">';
                        $tmp.html(imgIcon);
                    }
                }
                if($login.length>0)
                {
                    var loginout = 'http://passport.sina.cn/sso/logout?entry=wapsso&vt=4&r='+encodeURIComponent(window.location.href);
                    $login.html('退出').attr('href',loginout);
                }
                
            }
            return false;
        }   
    }
    if(win.sinaCnShare){
        win.sinaCnShare['wapLogin'] = new WapLogin();
        // Object.defineProperty(win.sinaCnShare,'wapLogin',{
        //     value: new WapLogin()
        // });     
    }
})(window, document)
}catch(e){throw new Error(e+" ./Utils.js");}
// @require("./WapLogin.js");

try{/**
*@author tingling@staff.sina.com.cn
*@date 20150821
*@fileoverview 本文件用于sina正文，主要功能包含各平台分享等功能
*require zepto.js utils.js WapLogin.js FavorCom.js PraiseCom.js
**/
/**
var __docConfig= { 
			__domain:'top',//文档所在域名
			__docId:'fxhcvsc4234435',//文档ID
			__docUrl:'http://top.sina.cn/zx/2015-08-21/tnews-ifxhcvsc4234435.d.html',//当前页面URL
			__cmntId:'gn:comos-fxhcvsf0998175:0',//评论ID
			__cmntTotal:'19784',//评论数
			__isGetUserInfo:'1',//是否需要用户信息
			__mainPic:'http://n.sinaimg.cn/transform/20150821/PNut-fxhehqr6129310.jpg',//图片地址
			__cmntListUrl:'http://cmnt.sina.cn/index?product=comos&index=fxhcvsc4234435&tj_ch=top', //为空时，页面不跳转
			__gspsId:'comos:fxhcvsc4234435',//微博分享用ID		
			__suda:'article_new_cms',
			__sudapageId:'2949',
			__title:'广州纪委批国企贪腐:全军覆没',
			__content:'',
			__tj_ch:'zx',//统计参数
			__tj_sch:'top',//统计参数
			__webURL:'http://top.sina.cn/zx/2015-08-21/tnews-ifxhcvsc4234435.d.html',
			__ispraise:1,//是否点赞点踩
			__responeTime:1440125325,
			__cateid:'sina_all',
			__cre:'newspagew',
			__media:'',			
			__colleid:'1440125325',
			__collekey:'9a76a51d6a9bddf54f3308f374ee90ed',
			__pkeys:'df8c8cfc575af69e7f615217e05e6522',
			__pValue:'fxhcvsc4234435',
			__api:'http://s.api.sina.cn/article/getall',
			__hotapi:'http://interface.sina.cn/wap_api/hotnews.d.html',
			__hotNewsNo:40			
		}
需要将分享图片的ID设置为j_ishare_pic
config = {
	imgid : '',		//分享的图片id，可为空
	imgClass : '',	//分享的图片类名，可为空
	imgURL : '',	//分享的图片URL，可为空，默认取
	title : '',		//分享的标题，可为空，若为空，取文章的标题
	content : '',	//分享的内容，可为空，若为空，去文章的描述
	targetURL : '',	//分享的到微博的url，可为空，若为空
	shareURL : '',	//当前文章的url,可为空
	isdoc : 1		//1，表示分享到微博为doc模式，0表示不是，若isdoc为0，则需要传图
}
**/
/**
	此类包含了分享、赞、收藏等功能
	节点插入
	css插入
	阶段判断
**/
;(function( win, doc){	
	window.ishare = true;
	var sinaCnShare = win.sinaCnShare;
	var MyShare = function(config){
		this.config = config || {};
		this.curLink = window.location.href;
		this.docConfig = win.__docConfig || {};
		//this.docConfig = (typeof(__docConfig)!='undefined' && __docConfig )|| {};
		this.shareConfig = {
			imgID		: this.config.imgid 	|| 'j_ishare_pic',
			imgClass	: this.config.imgClass 	|| 'j_cshare_pic',
			imgSrc		: this.config.imgURL 	|| this.docConfig.__mainPic || '',
			title		: this.config.title 	|| this.docConfig.__title || '',
			content		: this.config.content 	|| this.docConfig.__content || '',
			staticURL	: this.config.staticURL	|| 'http://o.share.sina.cn/ajpoint',
			targetURL	: this.config.targetURL || 'http://o.share.sina.cn/ajshare?vt=4',
			shareURL	: this.config.shareURL 	|| this.docConfig.__shareUrl || this.docConfig.__docUrl || this.curLink,
			isdoc		: this.config.isdoc 	|| this.docConfig.__isdoc || (this.docConfig.__gspsId && 1)|| 0
		};
		this.floatStatus = { 
			login : 0, platlist : 1,
			share : 2, fade : 3
		};
		this.platformsTo = {
			sweibo		: ['SinaWeibo','新浪微博'],
			friend  	: ['WechatFriends','微信好友'],
			fsircle		: ['WechatTimeline','微信朋友圈']
		};
		this.platformsFrom = {
			qqfriend	: "qqfriend", qqweichat	: "qqweichat",
			ucfriend	: "ucfriend", ucweichat	: "ucweichat"
		};
		this.ucPlatName	= {	
			iweibo:'kSinaWeibo',ifriend:'kWeixin',ifcircle:'kWeixinFriend',
			asweibo:'SinaWeibo',afriend:'WechatFriends',afcircle:'WechatTimeline'
		};
		this.qqAPISrc = {
			lower	:'http://3gimg.qq.com/html5/js/qb.js', 
			higher	:'http://jsapi.qq.com/get?api=app.share'
		};
		this.paths = {
			shareBase	: 'http://mjs.sinaimg.cn/wap/module/share_2.0/201509291635/',
			personal	: 'http://my.sina.cn/?vt=4'
		};
		this.shareWeiboContent = {
			contentRows	: [4,6],
			contentMax	: 88,
			userInfoUrl : 'http://interface.sina.cn/wap_api/wap_get_user_info.d.api?jsoncallback=',
			animate		: ['platformShow','sinaShow'],
			headimgsrc	: 'http://n.sinaimg.cn/dae7ff0c/20151008/headimg.png',							
			shareimgsrc	: 'http://mjs.sinaimg.cn/wap/online/public/images/addToHome/sina_114x114_v1.png'
		};
		this.element = {
			CLASS : {
				wxShareIco:'j_share_bg',shareBg:'shareBg',shareIcon:'j_share_platform',shareContentZone:'j_icontent',shareBtn:'j_shareBtn',platforms_big:'j_platforms_big',
				sinaShareContent:'j_sinaShareContent',submitBtn:'j_isunbmit',addFavor:'j_iadd_btn', sinaInfo:'sinaInfo',forbid:'forbid'
			},
			ID : {
				sharefloat:'j_sharebox',floatCross:'j_sharecross',shareContentid:'j_ishare_content',
				sharetitle:'j_shareTitle',sharecnum:'j_ishare_num',spicid:'j_ishare_pic',
				userInfo:'j_sinaInfo',userName:'j_user_name',userImg:'j_user_img',shareImg:'j_ishare_img',
				insertDom:['j_com_pics_op','j_com_art_op',]
			}
		};
		this.shareCallBack = ''; 
		this._domain = this.docConfig.__domain || this.curLink.split('//')[1].split('/')[0].split('.')[0];
		this.collect = {
			id	: this.docConfig.__colleid || '',
			key : this.docConfig.__collekey || ''
		};
		this.browserStatus = {
			forbid:0, lower:1, higher:2
		};
		this.curShareStatus = {
			UC : this.browserStatus.forbid, QQ : this.browserStatus.forbid
		};
		this.allPlatformInfo = {};
		this.myLogin = sinaCnShare.wapLogin;
		this.myUtility	= sinaCnShare.myUtility;
		this.getBrowserInfo = sinaCnShare.getBrowserInfo;
		this.systems 	= this.myUtility.getSystem();
	}
	MyShare.prototype = {
		tokenTimer : null,
		insertDOM : function( ele, domStr){
			this.myUtility.insertDOM( ele, domStr);
		},
		getScreenInfo : function(){
			return this.myUtility.getScreenInfo();
		},
		sudaLog : function(classID){
			return this.myUtility.sudaLog(classID);
		},
	    showEle : function(ele,isShow,showTime){
	    	this.myUtility.showEle(ele,isShow,showTime);
	    },
	    preventEvent : function(e){
	        this.myUtility.preventEvent(e);
	    },
	    getEvent : function(){
	    	return this.myUtility.getEvent();
	    },
	    ajaxByJsonp : function(url){
	    	this.myUtility.ajaxByJsonp(url);
	    },
		openLogin : function( callback, arg1 ){
			this.myLogin.openLogin( callback, arg1);
		},
		shareFromUC : function(shareInfo){
			//shareInfo = {imgID:'',title:'',content:'',imgSrc:'',url:'',platform:''}
			/**
			* 使用 getPos.getNodeInfoById("IdName")方法，返回一个数组对象，依次为【X轴,Y轴,宽度,高度】,如果ID不存在，则返回FALSE
			 */  
			var getPos = {
				getTop:function(e){
					var offset=e.offsetTop;
					if(e.offsetParent!=null) offset+=getPos.getTop(e.offsetParent);
					return offset;
				},
				getLeft:function(e){
					var offset=e.offsetLeft;
					if(e.offsetParent!=null) offset+=getPos.getLeft(e.offsetParent);
						return offset;
				},
				getCss3offsetTop:function(e){
					var css3offset=getComputedStyle(e,null).webkitTransform;
					if (css3offset=="none"){
						var css3offsetTop=0;
					}else{//存在CSS3属性
						var css3offsetTop=parseInt(css3offset.split(",")[5].replace(")",""))
					}
					if(e.parentNode.tagName!="BODY") css3offsetTop+=getPos.getCss3offsetTop(e.parentNode);
					return css3offsetTop;
				},
				getCss3offsetLeft:function(e){
					var css3offset=getComputedStyle(e,null).webkitTransform;
					if (css3offset=="none"){
						var css3offsetLeft=0;
					}else{//存在CSS3属性
						var css3offsetLeft=parseInt(css3offset.split(",")[4])
					}
					if(e.parentNode.tagName!="BODY") css3offsetLeft+=getPos.getCss3offsetLeft(e.parentNode);
					return css3offsetLeft;
				},
				getNodeInfoById:function(e){
					var myNode=document.getElementById(e);
					if (myNode){
						var pos=[getPos.getLeft(myNode)+getPos.getCss3offsetLeft(myNode), getPos.getTop(myNode)+getPos.getCss3offsetTop(myNode), myNode.offsetWidth,myNode.offsetHeight]
						return (pos)
					} else{
						return ""
					}
				}				
			}
			var _platforms 	= this.platformsTo,
				_ucPlatName = this.ucPlatName,
				_frompre 	= this.shareConfig.shareURL.indexOf('?')>=0?'&':'?',
				_fromPlat 	= this.platformsFrom,
				platform 	= shareInfo.platform,
				url			= shareInfo.url,
				delayTime	= 500;
		    this.layerStatus( this.floatStatus.fade );
		    this.sendShare(platform);
			if( typeof(ucweb) != "undefined" ) 
			{
				//alert('ucWeb:'+shareInfo.platform);
				setTimeout(function(){
					var UCBrowserText = ucweb.startRequest("shell.page_share", [shareInfo.title, shareInfo.content, shareInfo.url, shareInfo.platform, '', '我们正在看【'+shareInfo.title+'】，一起来看吧', getPos.getNodeInfoById(shareInfo.imgID)]);
				},delayTime);
				
			}
			else if( typeof(ucbrowser) != "undefined")
			{
				if(platform == _platforms.sweibo[0])
				{
					platform = _ucPlatName.iweibo;
				}
				else if( platform == _platforms.friend[0])
				{
					platform = _ucPlatName.ifriend;
					url +=  _frompre+ "from=" + _fromPlat.ucfriend;
				}
				else if( platform == _platforms.fsircle[0] )
				{
					platform = _ucPlatName.ifcircle;
					url +=  _frompre+ "from=" + _fromPlat.ucweichat;
				}			
				//alert(shareInfo.title+"/"+shareInfo.content+"/"+url+"/"+platform+'/'+shareInfo.imgID);
				setTimeout(function(){
					ucbrowser.web_share(shareInfo.title, shareInfo.content, url, platform, '', '', shareInfo.imgID);
				},delayTime);
			}
			else
			{
				//alert("sorry,your browser version not support!");
			}
		},
		shareFromQQ : function(shareInfo){
			//shareInfo = {imgID:'',title:'',content:'',imgSrc:'',url:'',platform:''}
			var _platforms 	= this.platformsTo,
				_frompre 	= this.shareConfig.shareURL.indexOf('?')>=0?'&':'?',
				_fromPlat 	= this.platformsFrom,
				platform 	= shareInfo.platform,
				url			= shareInfo.url;
			if( platform == _platforms.friend[0] )
			{
				platform = 1;
				url += _frompre+ "from=" + _fromPlat.qqfriend;
			}
			else if( platform == _platforms.fsircle[0] )
			{
				platform = 8;
				url +=  _frompre+ "from=" + _fromPlat.qqweichat;
			}
			else
			{
				platform = "";
			}
			
			// {"title":"养老|有地方养老金发放困难",
			// "description":"养老|有地方养老金发放困难",
			// "url":"http://info.3g.qq.com/g/s?icfa=news20160316035341&id=news_20160316024021&aid=news_ss&g_f=23839",
			// "img_url":"http://3gimg.qq.com/wap30/img/touch/icon.png",
			// "to_app":8,
			// "content_type":1}
			var	_shareInfo = {
					"title" : shareInfo.title,
					"description" : shareInfo.content,  
					"url" : url,
					"img_url" : shareInfo.imgSrc,
					//"img_title" : shareInfo.title,		//没有显示
					"to_app" : platform,
					//"cus_txt" : "请输入此时此刻想要分享的内容",
					//"content_type":1
				},
				success = -1;
		    this.layerStatus( this.floatStatus.fade );		    
		    this.sendShare(platform);
			if( typeof(browser) != "undefined" && typeof(browser.app) != "undefined" && this.curShareStatus.QQ == this.browserStatus.higher){
				//success = browser.app.share(_shareInfo);
				browser.app.share(_shareInfo);
			}
			else if(typeof(window.qb) != "undefined" && this.curShareStatus.QQ == this.browserStatus.lower)
			{
				window.qb.share(_shareInfo);
			}
			else{
				//alert("sorry,your browser version not support!");
			}
		},
		shareFromWeinxin : function(shareInfo){
			var _$wxFloat = $('.'+this.element.CLASS.wxShareIco),
				self = this;
			
		    this.layerStatus( this.floatStatus.fade );
		    if(_$wxFloat.length>0){
				_$wxFloat.show();
		    }else{
		    	//console.log("not insert weixin Float!");
		    	self.insertWeiXinTips();
		    	setTimeout(function(){
		    		$('.'+self.element.CLASS.wxShareIco).show();
		    	},300);
		    }
		},
		shareFromWeibo : function(shareInfo){
			var self = this,
				startTime = new Date().getTime(),
				endTimer = 0 ;
		    this.layerStatus( this.floatStatus.fade );
		    try{		    		
				WeiboJSBridge.invoke("openMenu", {}, function (params, success, code) {
				    if(!success) {}
				});
		    }
		    catch(e){
				console.log(e.message);
		    }	
			setTimeout(function(){
				endTimer = new Date().getTime();
				if(endTimer-startTime<250){
					self.shareFromWeinxin(shareInfo);
				}
			},200);
		},
		sendShare : function(type){
			
			var shareContent = this.shareConfig,
				oPost_url	= '',
				tj_ch		= this.docConfig.__tj_ch?this.docConfig.__tj_ch:'news',
				_platforms 	= this.platformsTo,
				_type 		= type || _platforms.sweibo[0],
				self 		= this;
			var csrftime 	= parseInt(new Date().getTime()/1000),
				codeStr 	= csrftime + "85e47ac07ac9d6416" + userInfo.uid,	//"2143409933";
				csrfcode 	= hex_md5(codeStr),			
				ititle 		= encodeURIComponent(shareContent.title),
				icontent 	= encodeURIComponent(shareContent.content),
				iimage 		= encodeURIComponent(shareContent.imgSrc),
				iurl 		= encodeURIComponent(checkURL(shareContent.shareURL,"wm=3049_all&from=qudao")),
				params 		= "&csrftime="+csrftime+"&csrfcode="+csrfcode+"&title="+ititle + "&content="+icontent+"&pic="+iimage+"&url="+iurl+"&isdoc="+shareContent.isdoc+"&tj_ch="+tj_ch;
			switch(type){
				case _platforms.friend[0]:
					oPost_url = shareContent.staticURL+'?load=weixinsingle&jsoncallback=cb0987';
					break;
				case _platforms.fsircle[0]: 
					oPost_url = shareContent.staticURL+'?load=weixingroup&jsoncallback=cb0987';
					break;
				default:
					oPost_url = shareContent.targetURL+'?load=weibo&jsoncallback=shareCallback';
					break;
			}
			this.layerStatus( this.floatStatus.fade );
			oPost_url += params;		
			this.ajaxByJsonp(oPost_url);
			
			window.shareCallback = function(data)
			{
				var remindTxt = '';
				switch(data.code){
					case -3:
						remindTxt = '分享失败!';
						break;
					case -2:
						remindTxt = '未登录!';
						break;
					case -1:
						remindTxt = '请求非法！';
						break;
					case 1:
						remindTxt = '分享成功！';
						break;
					default:
						remindTxt = '未知状态码 ' +data.code ;
						break;
				}
				if( typeof(self.shareCallBack) == 'function' )
				{
					//exchangeFunc(self.shareCallBack);
					self.shareCallBack();
				}
				else{
					self.showToken(remindTxt, true);
				}		
				self.sudaLog( 'public_sinashare_success' );
			}
			window.cb0987 = function(re){}
			function checkURL(url,params)
			{
				var alen = arguments.length;
				//兼容URL
				if(url.indexOf('?') == -1){
					url = url + '?';
					alen>1 && (url += params);
				}
				else{
					alen>1 && (url += "&" + params);
				}
				return url;
			}
			function exchangeFunc(name,param)
			{
				var re = eval(name);
				return re(param);
			}
			return;
		},
		callWeiboFloat : function(){
			var _contentConfig = this.shareWeiboContent,
				_shareConfig = this.shareConfig,
				_leaveNum = _contentConfig.contentMax - _shareConfig.content.length,
				_element = this.element;
			//更新微博分享的内容、剩余字数、图片
			$("#"+_element.ID.shareContentid).text(_shareConfig.content);	
			$( '#'+_element.ID.sharecnum ).html( _leaveNum );
			if( _leaveNum < 0)
			{
				$( '#'+_element.ID.sharecnum ).addClass('notice');
				$( '.'+_element.CLASS.submitBtn ).addClass( _element.CLASS.forbid );
			}
			else
			{
				$( '#'+_element.ID.sharecnum ).removeClass('notice');
				$( '.'+_element.CLASS.submitBtn ).removeClass( _element.CLASS.forbid );			
			}
			$('#'+_element.ID.shareImg).attr('src',_shareConfig.imgSrc);
			
			//显示分享浮层
			this.layerStatus( this.floatStatus.share );
		},
		getUserInfo : function(){
			if(checkLogin())
			{
		        getUserInfo(function(rs){
		        	userInfo.islogin = 1;
		        	userInfo.userface = rs.userface;
		        	userInfo.uname = rs.uname;
		        	userInfo.uid = rs.uid;
		        	//console.log(userInfo);
		        });	
			}
		},
		hideWeixinTimer : new Date(),
		insertWeiXinTips : function(){
			var _$wxBox = $('.'+this.element.CLASS.wxShareIco),
				self = this;
			if(_$wxBox.length<=0)
			{
				var arr = new Array(),
					src = "http://u1.sinaimg.cn/upload/2014/12/19/102181.png",
					width = 100,
					mySystem = this.allPlatformInfo.system,
					systems = this.systems;
				if(win.shareTipsPic && win.shareTipsPic.android && win.shareTipsPic.ios){
					if( mySystem == systems.android ) src = win.shareTipsPic.android;
					if( mySystem == systems.ios ) src = win.shareTipsPic.ios;
					width = '100%';
				}
				arr.push('<section>');
				//arr.push('<a class="sharebtn j_share_wx" href="javascript:;">');
				arr.push('<a class="j_share_wx" href="javascript:;">');
				arr.push('<span></span>');
				arr.push('</a>');
				arr.push('<a class="goback" href="javascript:;">');
				arr.push('</a>');
				arr.push('<div class="share_bg '+this.element.CLASS.wxShareIco+'" style="position:fixed;display:none;left:0;top:0;width:100%;height:100%;z-index:1009; background:rgba(0,0,0,.6);-webkit-animation:opacityIn 1s .2s ease both;">');
				arr.push('<p class="share_icon" style="clear:both; padding:10px; text-align:right;height:100%;background-position: right top; -webkit-animation:rotateUp 1s .8s ease both;z-index:9999;"><img src="'+src+'" alt="" width="'+width+'" /></p>');
				arr.push('</div>');
				arr.push('</section>');
				this.insertDOM( $('body'), arr.join(''));
			}
			_$wxBox = $('.'+this.element.CLASS.wxShareIco);
			_$wxBox.unbind('touchend',function(){$(this).hide();});
			_$wxBox.bind('touchend',function(event){
				event.preventDefault();
				self.hideWeixinTimer = new Date();
				$(this).hide();
			});
		},
		updateShareContent : function( _$platformBox ){
			//shareInfo = {imgID:'',title:'',content:'',imgSrc:'',url:'',platform:''}
			var  _shareConfig = this.shareConfig,
				_$title = $('title'),
				_imgSrc = {
					findById : $('#'+_shareConfig.imgID).length>0 && $('#'+_shareConfig.imgID).attr('src'),
					findByClass : $('.'+_shareConfig.imgClass).length>0 && $('.'+_shareConfig.imgID).eq(0).attr('src')
				},
				_shareInfo = {
					imgID 	: _shareConfig.imgID,
					title 	: _shareConfig.title || _$title.html(),
					content : _shareConfig.content || _$title.html(),
					imgSrc	: _shareConfig.imgSrc || this.docConfig.__mainPic || _imgSrc.findById || _imgSrc.findByClass || _shareConfig.imgSrc || this.shareWeiboContent.shareimgsrc,
					url		: _shareConfig.shareURL,
					platform : _$platformBox?(_$platformBox.data('platform')||_$platformBox.parents('.'+this.element.CLASS.shareIcon).data('platform')):''
				};
			_shareConfig.title = _shareInfo.title;
			_shareConfig.content = _shareInfo.content;
			_shareConfig.imgSrc = _shareInfo.imgSrc;
			
			return _shareInfo;
		},
		resetShareConfig : function( config ){
			var _config = config,
				_shareConfig = this.shareConfig,
				_eIDs = this.element.ID;
			this.shareConfig.imgID 		= _config.imgid 	|| _shareConfig.imgID;
			this.shareConfig.imgClass	= _config.imgClass 	|| _shareConfig.imgClass;
			this.shareConfig.imgSrc		= _config.imgSrc 	|| _shareConfig.imgSrc;
			this.shareConfig.title		= _config.title 	|| _shareConfig.title;
			this.shareConfig.content	= _config.content 	|| _shareConfig.content;
			this.shareConfig.staticURL	= _config.staticURL || _shareConfig.staticURL;
			this.shareConfig.targetURL	= _config.targetURL || _shareConfig.targetURL;
			this.shareConfig.shareURL	= _config.shareURL 	|| _shareConfig.shareURL;
			this.shareConfig.isdoc		= _config.isdoc 	|| _shareConfig.isdoc;
			$('title').html(this.shareConfig.title);
			$('#'+_eIDs.shareContentid).html(this.shareConfig.content);
			$('#'+_eIDs.shareImg).attr('src',this.shareConfig.imgSrc);
			//this.updateShareContent();
		},
		switchSharePlatform : function(shareInfo){
			var _allPlatformInfo = this.allPlatformInfo;
		    //调出浮层后，不管结果如何，都需要将浮层隐藏
		    //this.layerStatus( this.floatStatus.fade );
			if( _allPlatformInfo.isUCBrowser )
		    {
				this.shareFromUC(shareInfo);
			}
		     else if( _allPlatformInfo.isQQBrowser)
		    {
				this.shareFromQQ(shareInfo);
		    }
			else if( _allPlatformInfo.isWeixinApp || _allPlatformInfo.isQQApp ){
				this.shareFromWeinxin(shareInfo);
			}
			else if(_allPlatformInfo.isWeiboApp){
				this.shareFromWeibo(shareInfo);
			}
		     
			return; 
		},
		showToken : function( txt, isOnlyToken){
			this.myUtility.showToken( txt, isOnlyToken);
		},
		insertShareFloat : function(){
			var arr = [],
				userInfo = [],
				contentNum = [],
				_contentConfig = this.shareWeiboContent,			
				_shareConfig = this.shareConfig,
				_element = this.element,
				_platforms = this.platformsTo;
			
			contentNum.push((_contentConfig.contentMax-_shareConfig.content.length<0)?'notice':'');
			contentNum.push(_contentConfig.contentMax-_shareConfig.content.length);		
			
			//初始化值
			if(typeof(userInfo) != 'undefined' ){
				if(typeof(userInfo.userface) != 'undefined' && typeof(userInfo.uname) != 'undefined'){
					userInfo.push(userInfo.userface ? userInfo.userface :_contentConfig.headimgsrc);
					userInfo.push(userInfo.uname ? userInfo.uname : '新浪用户');
				}
				else{
					userInfo.push(_contentConfig.headimgsrc);
					userInfo.push('新浪用户');
				}
			}
			else{
				userInfo.push(_contentConfig.headimgsrc);			
				userInfo.push('新浪用户');			
			}
			
			//插入浮层节点
			arr.push('<section>');
			arr.push('<div class="'+_element.CLASS.shareBg+'" id="'+_element.ID.sharefloat+'">');
			arr.push('<div class="sharebox">');
			arr.push('<div class="float_cross fTitle" id="'+_element.ID.floatCross+'" data-sudaclick="public_share_close"></div>');
			arr.push('<div class="shareTitle fTitle" id="'+_element.ID.sharetitle+'">分享至微博</div>');
			arr.push('<div class="shareZone">');
			arr.push('<div class="platforms_big '+_element.CLASS.platforms_big+'">');
			arr.push('<ul>');
			arr.push('<li>');
			arr.push('<span class="'+ _element.CLASS.shareIcon +' splat_ico sina_big" data-platform="'+_platforms.sweibo[0]+'" data-sudaclick="public_sinaweibo"></span>');
			arr.push('<p>'+_platforms.sweibo[1]+'</p>');
			arr.push('</li>');
			arr.push('<li>');
			arr.push('<span class="'+ _element.CLASS.shareIcon +' splat_ico friend_big" data-platform="'+_platforms.friend[0]+'" data-sudaclick="public_wechatfriends"></span>');
			arr.push('<p>'+_platforms.friend[1]+'</p>');
			arr.push('</li>');
			arr.push('<li>');
			arr.push('<span class="'+ _element.CLASS.shareIcon +' splat_ico fcircle_big" data-platform="'+_platforms.fsircle[0]+'" data-sudaclick="public_wechattimeline"></span>');
			arr.push('<p>'+_platforms.fsircle[1]+'</p>');
			arr.push('</li>');
			arr.push('</ul>');
			arr.push('</div>');
			arr.push('<div class="sinaShareContent '+_element.CLASS.sinaShareContent+'">');
			arr.push('<div class="sinaInfo" id="'+_element.ID.userInfo+'">');
			arr.push('<span class="user_img" id="'+_element.ID.userImg+'">');
			arr.push('<img src="'+userInfo[0] +'"  style="width:100%;height:100%;"\/>‘');
			arr.push('</span>');
			arr.push('<span class="user_name" id="'+_element.ID.userName+'">'+userInfo[1]+'</span>');
			arr.push('</div>');
			arr.push('<div class="icontent '+_element.CLASS.shareContentZone+'">');
			arr.push('<textarea class="ishare_content" id="'+_element.ID.shareContentid+'">'+_shareConfig.content+'</textarea>');		
			arr.push('<span class="ishare_img">');
			arr.push('<img class="shareimg_style" src="'+_shareConfig.imgSrc +'" id="'+_element.ID.shareImg+'" style="width:32px;height:32px"/>');
			arr.push('</span>');
			arr.push('<span class="ishare_num"><span class="  '+contentNum[0]+'" id="'+_element.ID.sharecnum+'">'+contentNum[1]+'</span>字</span>');
			arr.push('</div>');
			arr.push('<button class="isubmit '+_element.CLASS.submitBtn+'" data-sudaclick="public_sinashare_submit">立即分享</button>');
			arr.push('</div>');
			arr.push('</div>');
			arr.push('</div>');
			arr.push('</div>');
			arr.push('</section>');
			
			$('body').append(arr.join(''));	
			
			//分享组件初始化各监听事件
			this.initFloatListner();
			
			return;
		},
		curTop : 0,
		floatZoneStatus : function(obj,pStatus,isZoneFlag){
			var oBox = $(obj),
				_floatStatus = this.floatStatus,
				tBox = (isZoneFlag == _floatStatus.platlist) ? oBox.find('li') : oBox,
				flag = pStatus ? 1 : 0,
				_contentConfig = this.shareWeiboContent,
				animation = pStatus ?  _contentConfig.animate[0] :  '' ,
				pDisplay = pStatus ? 'block' : 'none';
			
			//修改平台列表的透明度		
			if(pStatus){		
				//先将平台的透明度设置为0，否则会出现闪的情况
				oBox.css({'opacity' : 0});	
				setTimeout(function(){
						oBox.css({'opacity' : flag});
					},250);
				tBox.css({
					'-webkit-animation-name' : animation,
					'opacity' : flag,
					'display' : pDisplay
				});		
				if( tBox != oBox ){
					oBox.css({
						'display' : pDisplay
					});	
				}
			}
			else{
				tBox.css({
					'-webkit-animation-name' : animation,
					'opacity' : flag,
					'display' : pDisplay
				});	
				
				oBox.css({
					'opacity' : flag,
					'display' : pDisplay});	
			}
				     
			return;
		},
		updateUserInfo : function(){
	    	$('#'+this.element.ID.userImg).find('img').attr('src',userInfo.userface);
	    	$('#'+this.element.ID.userName).html(userInfo.uname);
		},
		hideBody : function( isTrue ){
			var bodyObj = $(document.body),
				 body = bodyObj.children();
				
			for( var o= 0; o<body.length ; o++ )
			{
				if( body[o].tagName != 'SCRIPT' && body[o].tagName != 'NOSCRIPT' && $(body[o]).find('.shareBg').length<=0  )
				{
					
					if( isTrue && $(body[o]).css('display') != 'none' )
					{
						$(body[o]).data('show','show');
						$(body[o]).hide();
					}
					else if( !isTrue )
					{
						if( $(body[o]).data('show')=='show' && $(body[o]).css('display') == 'none')
						{
							$(body[o]).show();
						}
						else
						{
							$(body[o]).data('show','');
						}
					}
				}
			}
			if(isTrue){
				bodyObj.css('overflow','hidden');
			}else{
				bodyObj.css('overflow','auto');
			}
		},
		changeFloatShow : function(status){
			var _floatStatus = this.floatStatus,
				_element = this.element;
			switch(status){
				case _floatStatus.platlist:
					this.hideBody(true);
					//背景出现
					this.showEle( '#'+_element.ID.sharefloat, true, 3000);
					this.showEle( '#'+_element.ID.floatCross, true);
					this.showEle( '#'+_element.ID.sharetitle, false);
					this.floatZoneStatus( '.'+_element.CLASS.platforms_big , true, _floatStatus.platlist);		
					this.floatZoneStatus( '.'+_element.CLASS.sinaShareContent, false, _floatStatus.share);											
					break;
				case _floatStatus.share:													
					this.hideBody(true);
					//背景出现
					this.showEle( '#'+_element.ID.sharefloat, true, 3000);
					this.showEle( '#'+_element.ID.floatCross, true);
					this.showEle( '#'+_element.ID.sharetitle, true);
					this.floatZoneStatus( '.'+_element.CLASS.platforms_big, false, _floatStatus.platlist);
					this.floatZoneStatus( '.'+_element.CLASS.sinaShareContent, true, _floatStatus.share);
					break;
				case _floatStatus.fade:
					this.hideBody(false);
					//隐藏背景+清除平台出现的动画
					this.showEle( '#'+_element.ID.sharefloat, false, 0);
					this.showEle( '#'+_element.ID.floatCross, true);
					this.floatZoneStatus( '.'+_element.CLASS.platforms_big, false, _floatStatus.platlist);	
					this.floatZoneStatus( '.'+_element.CLASS.sinaShareContent, false, _floatStatus.share);
					break;
				default:
					break;
			}
		},
		getUserInfoAgain : function(){
	    	var url = this.shareWeiboContent.userInfoUrl + 'userCallback',
	    		_element = this.element;
	    		
	    	this.ajaxByJsonp(url);
	    	window.userCallback = function(re)
    		{
		    	userInfo.userface = re.result.data.userface;
		    	userInfo.uname = re.result.data.uname;
		    	    	
		    	$('#'+_element.ID.userImg).find('img').attr('src',userInfo.userface);
		    	$('#'+_element.ID.userName).html(userInfo.uname);
		    	
		    	return;
    		}
	    	return;
	    },
	    isScrollTop : false,
		layerStatus : function( sStatus , callback, arg1){
			var oMeta		= document.getElementsByName('viewport')[0],
				mateContent = { 
					hide:"width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no, minimal-ui",
					show:"width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no"},
				_floatStatus = this.floatStatus,
				_element = this.element;
					
			sStatus = sStatus ? sStatus : _floatStatus.login;
			switch( sStatus )
			{	
				case _floatStatus.login:
					this.openLogin(callback, arg1);				
					break;
				case _floatStatus.platlist:
					if( !this.isScrollTop )
					{
						this.curTop = document.body.scrollTop;
					}
					oMeta.content = mateContent.hide;				
					setTimeout(function(){ 
	  					window.scrollTo(0, 1); 
						}, 200);
	  				this.isScrollTop = true;				
					this.changeFloatShow(_floatStatus.platlist);												
					break;
				case _floatStatus.share:			
					if( typeof(userInfo) != 'undefined' && userInfo ){
						if( !this.isScrollTop )
						{
							this.curTop = document.body.scrollTop;
						}
						oMeta.content = mateContent.hide;			
						setTimeout(function(){ 
	    					window.scrollTo(0, 1); 
						}, 200);
	  					this.isScrollTop = true;	
						this.changeFloatShow(_floatStatus.share);			
						this.updateUserInfo();
						
						//用户头像为空时，通过异步获取用户头像
						if( $('#j_user_img').find('img').attr('src') == window.location.href || $('#j_user_img').find('img').attr('src') == "")
						{
							this.getUserInfoAgain();
						}
					}
					else{			
						this.openLogin (this.layerStatus.bind(this),_floatStatus.share);
					}
					break;
				case _floatStatus.fade:				
					oMeta.content = mateContent.show;
					this.changeFloatShow(_floatStatus.fade);
									
					//分享输入框恢复原高度
					this.floatContentListner(false);
					//this.favorEvent(false);
					if( this.isScrollTop )
					{
						document.body.scrollTop = this.curTop;
					}
					this.isScrollTop = false;
					this.isLock = false;
					break;
				default:
					break;			
			}
			return;
		},
		isLock : false,
		wantShare : function( isTrue, callback){
			var _element = this.element,
				_allPlatformInfo = this.allPlatformInfo,
				_browserStatus = this.browserStatus,
				_curBrowserStatus = this.curShareStatus,
				_shareInfo = {};
			// if(!this.isLock)
			// {
			this.isLock = true;
	    	if(arguments.length>1)
	    	{
	    		this.shareCallBack = callback;
	    	}
	    	if( isTrue )
	    	{
	    		_shareInfo = this.updateShareContent();
	    	}
	    	if( $('.'+_element.CLASS.shareBg).length<=0 )
			{
				this.insertShareFloat();		//插入分享浮层
			}
			this.showToken();
			//分享到微信、微博
			if(_allPlatformInfo.isWeixinApp || _allPlatformInfo.isWeiboApp)
			{
				this.switchSharePlatform(_shareInfo);
			}		
			//判断是否为qq&uc，否则弹出微博页面
		    else if( (_curBrowserStatus.QQ!=_browserStatus.forbid 
		    		|| _curBrowserStatus.UC!=_browserStatus.forbid ) 
		    		&& !_allPlatformInfo.isWeixinApp)
		    {
				this.layerStatus( this.floatStatus.platlist );
		    }
			else
			{
				//this.callWeiboFloat();
				this.layerStatus( this.floatStatus.share );
			}
			//}
	    },
		floatPlatformListner : function(){
			$( '.' + this.element.CLASS.shareIcon ).on('click',function(){});   		
	   	},
	   	floatCloseListner : function(){
	   		var self = this;
			$('#'+this.element.ID.floatCross).on( 'click ', function(){
				self.layerStatus( self.floatStatus.fade );
			});
			return;
		},
		floatContentListner : function( flag ){
			var _element = this.element,
				$sinaShare =  $('.'+_element.CLASS.sinaShareContent),
				$contentzone = $( '.'+_element.CLASS.shareContentZone ),
				$contentedit = $('#'+_element.ID.shareContentid ),
				$userInfo = $('.' + _element.CLASS.sinaInfo),
				$sharefloat = $('#'+_element.ID.sharefloat),
				$leavenum = $( '#'+_element.ID.sharecnum ),
				$submitbtn = $( '.'+_element.CLASS.submitBtn ),
				_contentConfig = this.shareWeiboContent,
				_shareContent = this.shareConfig,
				bodyHeight = this.getScreenInfo().height,
				self = this;
				
				
			var touchEvent = function(){
				if( $sinaShare.css('display') == 'block' )
				{
					var $contentVal = document.getElementById(_element.ID.shareContentid).value,
					$leaveval = _contentConfig.contentMax-$contentVal.length;				
					$leavenum.html( $leaveval );
					if( $leaveval < 0 || $leaveval == _contentConfig.contentMax ){
						$leavenum.addClass('notice');
						$submitbtn.addClass( _element.CLASS.forbid );
					}
					else{
						$leavenum.removeClass('notice');	
						$submitbtn.removeClass( _element.CLASS.forbid );
					}
					_shareContent.content = $contentVal;
				}
			};
				
			if( !flag )
			{
				$contentzone.css({height:'140px'});
				$contentedit.attr('rows',_contentConfig.contentRows[1]);
			}
			else{
				
				$( '#'+_element.ID.shareContentid )
				.on('click tap',function(){
					var txt = $contentedit .html();
					
					self.showToken();
					$contentedit.focus();
				})
				.on('keyup',touchEvent)
				.focus(function(){
					$contentzone.css({height:'85px'});
					$(this).attr( 'rows', _contentConfig.contentRows[0]);
					$('.sharebox').css({
						'margin-top':'40px'
					});
					$('.shareBg').css( "height", (bodyHeight+50)+"px");
				})
				.blur(function(){
					$(this).attr('rows',_contentConfig.contentRows[1]);
					$('.sharebox').css({'margin-top':'10px'});
					$('.shareBg').css("height",(bodyHeight+10)+"px");
				});
											
				document.addEventListener('touchend',touchEvent, false);
			}			
			return;
		},
		floatSubmitListner : function(){
			var self = this,
				_element = this.element;
			$( '.'+_element.CLASS.submitBtn ).each(function(){
				$(this).on('click',function(){
					self.showToken();
					
					if( !$(this).hasClass(_element.CLASS.forbid) ){
						self.sendShare();
					}
				})
			});
			return;
		},	
		initFloatListner :  function(){
			var bodyHeight = this.getScreenInfo().height;
			this.floatPlatformListner();
			this.floatCloseListner();						//监听关闭浮层事件		
			this.floatContentListner(true);				//监听微博分享内容事件
			this.floatSubmitListner();					//提交微博分享监听事件
			
			$('.'+this.element.CLASS.shareBg).css( "height", (bodyHeight+50)+"px");
		},
		shareListner : function(){
			var self = this;
			$('.'+self.element.CLASS.shareBtn).on('click tap',function(){});
			window.addEventListener('click', function(ev){
			   var	tarObj		= ev.target || self.getEvent().target,
					_$target	= $(tarObj),
					_commentID 	= '#j_comment_nav',
					_$comment	= $(_commentID),
					_shareInfo	= self.updateShareContent(_$target),
					_element	= self.element,
					_platforms	= self.platformsTo,
					isucBrowser = self.allPlatformInfo.isUCBrowser,
					isTimePermit = (new Date()).getTime()-self.hideWeixinTimer.getTime()>500;
			   if(	_$target.hasClass( _element.CLASS.shareBtn) ||
			   		_$target.parents('.'+ _element.CLASS.shareBtn).length>0 ||
			   		_$target.hasClass( 'j_share_btn') ||
			   		_$target.parents('.j_share_btn').length>0  )
			   {
			   		self.preventEvent(ev);	
			   		self.wantShare();
			   }
			   else if( isTimePermit && (_$target.hasClass( _element.CLASS.shareIcon ) || 
			   		_$target.parents('.'+ _element.CLASS.shareIcon).length>0))
			   {
			   		//alert("you click btn!");
					if( $('.'+_element.CLASS.shareBg).length<=0 )
					{
						self.insertShareFloat();		//插入分享浮层					
					}
					self.showToken();
					if(_shareInfo.platform==_platforms.sweibo[0] )
					{
						self.callWeiboFloat();
					}
					else if( isucBrowser ){
						self.showEle(_commentID,false);
						self.shareFromUC(_shareInfo);
						
						setTimeout(function(){
							self.showEle(_commentID,true);
						},600);
					}
					else
					{
						self.switchSharePlatform(_shareInfo);
					}	
			   	
			   }
			   
				var _$loginMask = $('#ST_outLogin_mask'),
					_$shareFloat = $('#j_sharebox'),
					_crossID	= '#j_sharecross',
					_$cross 	= $(_crossID);
						
			   if( _$loginMask.length>0 &&  _$shareFloat.length>0 && _$shareFloat.css('display') != 'none' )
			   {
					if( _$loginMask.css('display') != 'none' )
					{
						self.showEle(_crossID,false);
					}
					else if( _$loginMask.css('display') == 'none' )
					{
						self.showEle(_crossID,true);
					}
			 	}
			   
			});
		},
		initUtility : function(){
			var self = this;
			//self.insertWeiXinTips();//初始化微信提示浮层
			self.getUserInfo();
			self.shareListner();
		},
		initBrowserVersion : function(){
			this.curShareStatus = this.getBrowserInfo;
			return;
		},
		loadQQAPI : function(){
			var isQQBrowser = this.allPlatformInfo.isQQBrowser,
				self = this;
			if(isQQBrowser)
			{
				var api = this.qqAPISrc,
					src = (this.curShareStatus.QQ<this.browserStatus.higher)?api.lower:api.higher,
					_script = document.createElement('script'),
					_head 	= document.getElementsByTagName('head')[0];
				//需要等加载过qq的接口文档之后，再去初始化分享组件
				_script.onload = function(){ 
					self.initUtility();
				};
				_script.src = src;
				_head.appendChild(_script);
			}
			else{
				this.initUtility();
			}
		},
		init : function(){
			this.allPlatformInfo = this.myUtility.getAllPlatformsInfo();
			this.initBrowserVersion();
			this.loadQQAPI();
		}
	};
	if(win.sinaCnShare){
		win.sinaCnShare['main'] = new MyShare();
		// Object.defineProperty(win.sinaCnShare,'main',{
		// 	value: new MyShare()
		// });
	}
})(window, document);
window.addEventListener('load',function(){
	setTimeout(function(){
		window.sinaCnShare.main.init();
	},100);
});
//alert(myStringify(window.sinaCnShare.getBrowserInfo));
//window.sinaCnShare.main.wantShare();
}catch(e){throw new Error(e+" ./MyShare.js");}

try{/**
*@author tingling@staff.sina.com.cn
*@date 20150821
*@fileoverview 本文件用于sina正文，主要功能包含各收藏等功能
*require zepto.js utils.js WapLogin.js
**/
;(function( win, doc){
	var sinaCnShare = win.sinaCnShare;
	var FavorCom = function(){
		this.docConfig = (typeof(__docConfig)!='undefined' && __docConfig ) || {};
		this.curLink = window.location.href;
		this.favorConfig = {
			btnClass : 'j_iadd_btn',
			favorId : '',
			URL 	: 'http://data.api.sina.cn/api/count/count.php?act=',
			backURL : this.docConfig.__docUrl || this.curLink,
			colleid : this.docConfig.__colleid 	|| '',
			collekey: this.docConfig.__collekey || '',
			docid	: this.docConfig.__gspsId || '',		
			domain 	: this.docConfig.__domain || this.curLink.split('//')[1].split('/')[0].split('.')[0],
			number	: 0
		};
		this.tokenTxt = {
			addOK		: '您已收藏，请到个人中心查看',
			addFail 	: '收藏失败!',
			cancelOK 	: '已取消收藏',
			cancelFail	: '取消收藏失败!'
		};
		this.status		= {	INIT:0,ADD:1,CANCEL:2},
		this.myUtility	= sinaCnShare.myUtility;
		this.myLogin	= sinaCnShare.wapLogin;
	}
	FavorCom.prototype = {
		showToken : function(txt,isOnlyToken){
			this.myUtility.showToken(txt,isOnlyToken);
		},
		ajaxByJsonp : function(url){
			this.myUtility.ajaxByJsonp(url);
		},
		getShowNum : function(number){
			return this.myUtility.getShowNum(number);
		},
		openLogin : function( callback, arg1 ){
			this.myLogin.openLogin( callback, arg1);
		},
		favorInit : function(){
			var _favorConfig = this.favorConfig,
				_status = this.status,
				self = this;
			//初始化收藏装，不要提示
			//this.favorEvent( $( '.'+_favorConfig.btnClass).eq(0),_status.INIT);
			this.favorEvent(_status.INIT);
			$('body').on("click tap",function(){});
			document.addEventListener('click', function(ev){
	        	var obj = ev.target || self.getEvent().target,
	        		_$target = $(obj);
				if( _$target.hasClass(_favorConfig.btnClass))
				{
					var status = _status.ADD;
					if(_$target.hasClass('on'))
					{
						status =  _status.CANCEL;
					}
					self.showToken();
					self.favorEvent(status);
				}
					
	       	}, false);
		},
		favorEvent : function(status){
			var _favorConfig = this.favorConfig,
				_status = this.status,
				_$favorBtn = $('.'+_favorConfig.btnClass),
				self = this;
			if( _favorConfig.colleid && _favorConfig.collekey ){
		      	var uid		= userInfo.uid || '',
					jsoncallback = '',
					_curStatus	= (typeof(status) != 'undefined')? status : _status.ADD;
		           
				if( userInfo && userInfo.islogin )
				{			
									
					if( _curStatus == _status.INIT )
					{
		          		jsoncallback = '&op=isFav&jsoncallback=initFavorCallback';
		          	}
		          	else if(_curStatus == _status.CANCEL && _favorConfig.favorId )
		          	{
		          		jsoncallback = '&op=del&fid='+_favorConfig.favorId+'&jsoncallback=cancelFavorCallback';
		          	}
		          	else
		          	{
		          		jsoncallback = '&op=add&jsoncallback=addFavorCallback';
		          	}
		          	     	
					//收藏操作 
					var url = 'http://my.sina.cn/aj/artfavorite?docid='+ _favorConfig.docid +'&backurl='+ _favorConfig.backURL +'&tj_ch=' + _favorConfig.domain+'&ch=&csrftime='+ _favorConfig.colleid +'&csrfcode='+ _favorConfig.collekey +'&channel='+ _favorConfig.domain +jsoncallback;
					this.ajaxByJsonp(url);
		  		}
		  		else if( _curStatus == _status.ADD ){
		  			//登录
		  			self.openLogin(self.favorEvent.bind(self));
		  		}				     
			}
			window.cancelFavorCallback = function(data) {
				//请求发送成功，根据获取结果显示不同提示内容
				_$favorBtn.data('loading', 'no');
				if(_$favorBtn && data.status == 1){
					_$favorBtn.removeClass('on').html('收藏');	              
					self.showToken(self.tokenTxt.cancelOK, true);
					_favorConfig.favorId = null;
				}
				else if(data && data.code == 2){
		        	document.location.href = data.data;
				}
				else{
					self.showToken(self.tokenTxt.cancelFail, true);
				}
			};
			//收藏回调函数
			window.addFavorCallback = function(data) {
				//请求发送成功，根据获取结果显示不同提示内容
				_$favorBtn.data('loading', 'no');
				if(data && data.code == 1){
		            _$favorBtn.addClass('on').html('已收藏'); 
					self.showToken(self.tokenTxt.addOK, false);
					_favorConfig.favorId = data.data;
				}
				else{
					self.showToken(self.tokenTxt.addFail, true);
				}
			};
			window.initFavorCallback = function(data) {
				//请求发送成功，根据获取结果显示不同提示内容
				if(data && data.code == 1 && data.data.id){
					_$favorBtn.addClass('on').html('已收藏');
					_favorConfig.favorId = data.data.id;
				}
			};
		},
		init : function(){
			this.favorInit();
		}
	}
	if(win.sinaCnShare){
		win.sinaCnShare['favorCom'] = new FavorCom();
		// Object.defineProperty(win.sinaCnShare,'favorCom',{
		// 	value: new FavorCom()
		// });
	}
})(window, document);
window.addEventListener('load',function(){
	setTimeout(function(){
		window.sinaCnShare.favorCom.init();
	},100);
});
}catch(e){throw new Error(e+" ./FavorCom.js");}
